import { Reducer } from 'redux';
import { CarClassActionTypes, CarClassState, GET_ACRISS_CODES } from '../types/carClass.types';

const initialState: CarClassState = {
  acrissCodes: []
};

export const carClassReducer: Reducer<CarClassState> = (
  state:CarClassState = initialState, action
) => {
  switch ((action as CarClassActionTypes).type) {
    case GET_ACRISS_CODES:
      return {
        acrissCodes: action.payload.acrissCodes
      };
    default:
      return state;
  }
};
